import {ChangeDetectionStrategy, Component} from '@angular/core';
import {HinweisboxTypeEnum} from "../../../shared/components/hinweisbox/hinweisbox-type.enum";
import {SectionComponent} from "../../../shared/components/structure/section/section.component";
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-datenschutz',
  imports: [
    SectionComponent,
    I18NextPipe
  ],
  templateUrl: './datenschutz.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DatenschutzComponent {

  protected readonly HinweisboxTypeEnum = HinweisboxTypeEnum;
}
